import { QueryHookOptions, useQuery } from '@apollo/client';

import { GET_TASKS_FOR_PROGRAM_QUERY } from '@frontend/app/queries/GetTasksForProgramQuery';
import { GetTasksForProgramQuery, GetTasksForProgramQueryVariables } from '../queries/types/GetTasksForProgramQuery';

type IOptions = QueryHookOptions<GetTasksForProgramQuery, GetTasksForProgramQueryVariables>;

export const useGetTasksForProgramQuery = (options: IOptions = {}) => {
  return useQuery<GetTasksForProgramQuery, GetTasksForProgramQueryVariables>(GET_TASKS_FOR_PROGRAM_QUERY, {
    ...options,
  });
};
